import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import DetectedLanguageLabel from './DetectedLanguageLabel';
import TranslateButton from './TranslateButton';
import TranslatedDiscussionTitle from './TranslatedDiscussionTitle';
import TranslationState from '../states/TranslationState';

/**
 * Discussion hero title plus its translate control.
 */
export default class DiscussionTitle extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.translationState = new TranslationState(vnode.attrs.discussion, 'discussion');
    this.subtree?.check(() => this.translationState.loading, () => this.translationState.showing, () => this.translationState.currentTranslation);
  }
  view() {
    return m("div", {
      className: "DiscussionTitle-container"
    }, this.titleItems().toArray());
  }
  titleItems() {
    const items = new ItemList();
    const {
      languages,
      iconOnly
    } = this.attrs;
    const discussion = this.attrs.discussion;
    let currentDetectedLang = discussion.detectedLang?.() || '';
    const user = app.session.user;
    if (currentDetectedLang === app.translator.getLocale() && !user?.preferences()?.['itqan-translate.labelAllSource']) {
      currentDetectedLang = '';
    }
    if (this.translationState.showing) {
      items.add('title-translated', m(TranslatedDiscussionTitle, {
        state: this.translationState
      }), 45);
    } else {
      items.add('title-original', m("h1", {
        className: "DiscussionHero-title"
      }, discussion.title()), 50);
      if (currentDetectedLang) {
        items.add('title-original-label', m(DetectedLanguageLabel, {
          detectedLang: currentDetectedLang,
          context: "discussion"
        }), 40);
      }
    }
    items.add('title-translate-action', m("div", {
      className: "DiscussionTranslationAction"
    }, m(TranslateButton, {
      languages: languages,
      detectedLang: currentDetectedLang,
      onTranslate: code => this.translationState.loadTranslation(code),
      iconOnly: iconOnly
    })), 30);
    return items;
  }
}
flarum.reg.add('itqan-translate', 'forum/components/DiscussionTitle', DiscussionTitle);